// extracted by mini-css-extract-plugin
export default {"deck":"styles_deck__DjC-v","noEvents":"styles_noEvents__df7gp","cards":"styles_cards__xX51V","card":"styles_card__y79Fo","cardContent":"styles_cardContent__96atE"};